module.exports = __webpack_public_path__ + "client/projects/assets/job-one/nationbuilder-logo.svg";


//////////////////
// WEBPACK FOOTER
// ./client/projects/assets/job-one/nationbuilder-logo.svg
// module id = 279
// module chunks = 0